import { useEffect, useState } from 'react'

export default function useOnline() {
  const pingUrl = window.location.origin
  //   const pingUrl = 'https://staging-agent.netlify.app/'
  const [isOnline, setIsOnline] = useState(true)

  useEffect(() => {
    const checkInternet = async () => {
      try {
        const controller = new AbortController()
        const timeoutId = setTimeout(() => controller.abort(), 5000)
        await fetch(pingUrl, { method: 'HEAD', signal: controller.signal })
        clearTimeout(timeoutId)
        setIsOnline(true)
      } catch {
        setIsOnline(false)
      }
    }

    checkInternet()

    window.addEventListener('online', checkInternet)
    window.addEventListener('offline', () => setIsOnline(false))

    return () => {
      window.removeEventListener('online', checkInternet)
      window.removeEventListener('offline', () => setIsOnline(false))
    }
  }, [])

  return isOnline
}
